import { inject } from 'vue';
import { VueCookies } from 'vue-cookies';

import { setLocale } from '@/plugins/i18n';
import { userService } from '@/services/user.service';
import { Locales } from '@/store/language.interface';

// A language the user picked themselves. Languages the app sets on its own
// (community default, single-language community, locale in the URL) go through
// setLocale directly and are never saved to the account.
export function useLocaleChoice() {
  const cookies = inject<VueCookies>('$cookies');

  function chooseLocale(locale: Locales): void {
    cookies.set('locale', locale);
    setLocale(locale);
    void userService.recordLanguageChoice(locale);
  }

  return { chooseLocale };
}
